<div class="log-cinematic-selection-bar">
    <button
        class="log-cinematic-selection-bar__arrow-button log-cinematic-selection-bar__arrow-button-left"
        (click)="handlePreviousClick()"
        [disabled]="busy || !hasPrevious"
    >
        <cds-icon
            [ngClass]="{ 'log-cinematic-selection-bar__arrow-icon--deactivated': busy || !hasPrevious }"
            shape="arrow"
            direction="left"
            status="info"
        ></cds-icon>
    </button>

    <div class="log-cinematic-selection-bar__current-timestamp">
        <ng-container *ngIf="!busy; else defaultTimestamp">
            {{ timestamp | aviDate:timeFormat }}
        </ng-container>
        <ng-template #defaultTimestamp>
            --/-- --:--:-- --
        </ng-template>
    </div>

    <button
        class="log-cinematic-selection-bar__arrow-button log-cinematic-selection-bar__arrow-button-right"
        (click)="handleNextClick()"
        [disabled]="busy || !hasNext"
    >
        <cds-icon
            [ngClass]="{ 'log-cinematic-selection-bar__arrow-icon--deactivated': busy || !hasNext }"
            shape="arrow"
            direction="right"
            status="info"
        ></cds-icon>
    </button>
</div>
